import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';

import { AdvancedComponent } from './advanced.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { EvolutionParameterComponent } from './evolution-parameter/evolution-parameter.component';
import { PartitionCursorsComponent } from './partition-cursors/partition-cursors.component';
import { PartitionCursorsChartComponent } from './partition-cursors-chart/partition-cursors-chart.component';
import { PartitionCursorsMjpComponent } from './partition-cursors-mjp/partition-cursors-mjp.component';
import { PartitionCursorsChartMjpComponent } from './partition-cursors-chart-mjp/partition-cursors-chart-mjp.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule
    ],
    declarations: [
        AdvancedComponent,
        BreadcrumbComponent,
        EvolutionParameterComponent,
        PartitionCursorsComponent,
        PartitionCursorsChartComponent,
        PartitionCursorsMjpComponent,
        PartitionCursorsChartMjpComponent
    ]
})
export class AdvancedModule { }
